import React from 'react';
import PropTypes from 'prop-types';
import ReduxModal from 'components/reduxModal';

const MODAL_ID = 'password-reset-confirm-info';

const PasswordResetConfirmInfo = ({ close }) => (
  <ReduxModal
    id={MODAL_ID}
  >
    {(Modal) => (
      <div>
        <Modal.Heading title="Hasło zostało zmienione" subtitle="Zaloguj się używając nowego hasła" />
        <Modal.Footer>
          <button type="button" onClick={close} className="full-btn has-margin-left">OK, rozumiem</button>
        </Modal.Footer>
      </div>
    )}
  </ReduxModal>
);

PasswordResetConfirmInfo.propTypes = {
  close: PropTypes.func.isRequired
}

export default PasswordResetConfirmInfo;


// WEBPACK FOOTER //
// ./src/components/globalModals/PasswordResetConfirmInfo.jsx